import { spacing } from '@naf/theme';
import styled from '@emotion/styled';

export const MetaDataWrapper = styled.div`
  padding-bottom: ${spacing.space24};
  display: flex;
  flex-direction: column;
`;

export const EditorWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Editor = styled.span`
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.25rem;
`;

const BaseText = styled.span`
  font-size: 0.875rem;
  line-height: 1.25rem;
`;

export const Position = styled(BaseText)`
  font-style: italic;
  font-weight: 400;
`;

export const PublishedDate = styled(BaseText)`
  font-weight: 400;
`;

export const UpdateDate = styled(BaseText)`
  margin-top: ${spacing.space16};
  font-weight: 700;
`;
